import React from 'react'
import { Box, Flex, Link, Text } from "@chakra-ui/react"
import { AiFillFolderOpen, AiFillGithub } from "react-icons/ai"
import { ExternalLinkIcon } from "@chakra-ui/icons"

const OpenSourceProjectCard = ({title, description, githubLink, liveLink, tools}) => {
    return (
        <Box
            // border="1px solid red"
            w={320}
            h={320}
            p="1.5rem"
            backgroundColor="secondary.dark"
            position="relative"
        >
            <Flex
                justifyContent="space-between"
                alignItems="flex-start"
            >
                <AiFillFolderOpen size={50} />
                <Flex
                    alignItems="center"
                >
                    <Link
                        isExternal
                        _focus={{ textDecoration: "none" }}
                        _hover={{
                            textDecoration: "none",
                        }}
                        href={githubLink}
                    >
                        <AiFillGithub size={23} />
                    </Link>
                    <Link
                        ml="1rem"
                        isExternal
                        _focus={{ textDecoration: "none" }}
                        _hover={{
                            textDecoration: "none",
                        }}
                        href={liveLink}
                    >
                        <ExternalLinkIcon boxSize={23} />
                    </Link>
                </Flex>
            </Flex>
            <Text fontSize="1.5rem">
                {title}
            </Text>
            <Text color="text.light" mt="1rem" >
               {description}
            </Text>
            <Flex
                position="absolute"
                left="1.5rem"
                bottom="1.5rem"
                mt="2rem"
            >
                {tools.map((tool) => {
                    return <Text mr="1rem" >{tool}</Text>
                })}
            </Flex>
        </Box>
    )
}

export default OpenSourceProjectCard